import React from 'react';

import Button from '@components/Button';
import Input from '@components/Input';
import ModalBase from '@components/ModalBase';

import { getEmptyErrorState } from '@utils/AppUtil';
import CyberdyneValidator from '@utils/cyberdyneValidator';
import ErrorMessageGenerator from '@utils/ErrorMessageGenerator';

export interface IFaqModalProps {
  show: boolean;
  elevioAccountId: string;
  onClose: (e: React.SyntheticEvent<any>) => void;
  onSubmit: (elevioAccountId: string) => (e: React.SyntheticEvent<HTMLButtonElement>) => void;
}

interface IFaqModalState {
  elevioAccountId: string;
  error: {
    elevioAccountId: IFieldValidation;
  };
}

const errMsgGen = new ErrorMessageGenerator();
const cyberdyneValidator = new CyberdyneValidator();

class FaqModal extends React.Component<IFaqModalProps, IFaqModalState> {
  constructor(props: IFaqModalProps) {
    super(props);

    this.state = this.getEmptyState();
  }

  componentDidUpdate(prevProps: IFaqModalProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      this.setState(this.getEmptyState());
    }
  }

  getEmptyState = (): IFaqModalState => ({
    elevioAccountId: this.props.elevioAccountId || '',
    error: {
      elevioAccountId: getEmptyErrorState(),
    },
  });

  validateForm = () => {
    let isValid = true;
    const elevioAccountId = (this.state.elevioAccountId || '').trim();
    const { error } = this.getEmptyState();

    if (cyberdyneValidator.isEmptyValue(elevioAccountId)) {
      error.elevioAccountId = {
        errorState: IValidationState.ERROR,
        errorMessage: errMsgGen.getMandatoryFieldMessage('Account ID'),
      };

      isValid = false;
    } else if (cyberdyneValidator.isStringGreaterThanLength(elevioAccountId, 100)) {
      error.elevioAccountId = {
        errorState: IValidationState.ERROR,
        errorMessage: errMsgGen.getCharacterLimitMessage('Account ID', 100),
      };

      isValid = false;
    }
    this.setState({ error });

    return isValid;
  };

  onSubmit = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    if (this.validateForm()) {
      const elevioAccountId = this.state.elevioAccountId.trim();
      this.props.onSubmit(elevioAccountId)(e);
    }
  };

  handleChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  renderAccountIdField = () => (
    <Input
      field={{
        label: 'Account ID',
        type: CustomFieldType.TEXT,
        isRequired: true,
        value: this.state.elevioAccountId || '',
      }}
      error={this.state.error.elevioAccountId}
      width={4}
      name="elevioAccountId"
      onChange={this.handleChange}
    />
  );

  renderBody = () => <div className="accoutnId__body">{this.renderAccountIdField()}</div>;

  renderFooter = () => (
    <div className="accoutnId__footer">
      <Button bsStyle={ButtonStyle.DEFAULT} onClick={this.props.onClose} content="Cancel" />
      <Button bsStyle={ButtonStyle.PRIMARY} onClick={this.onSubmit} content="Save" />
    </div>
  );

  render() {
    return (
      <ModalBase
        show={this.props.show}
        onClose={this.props.onClose}
        titleElement={this.props.elevioAccountId ? 'Edit FAQ Configuration' : 'FAQ Configuration'}
        bodyElement={this.renderBody()}
        footerElement={this.renderFooter()}
        className="faq-modal"
      />
    );
  }
}

export default FaqModal;
